// 保存token到localStorage
export function setToken(token) {
  localStorage.setItem('token', token)
}

// 获取token
export function getToken() {
  return localStorage.getItem('token')
}

// 移除token
export function removeToken() {
  localStorage.removeItem('token')
}

// 检查是否已登录
export function isAuthenticated() {
  // 开发环境下始终返回已登录状态，方便调试
  // if (process.env.NODE_ENV === 'development') {
  //   return true
  // }
  return !!getToken()
}

// 保存用户信息
export function setUserInfo(userInfo) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

// 获取用户信息
export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo')
  return userInfo ? JSON.parse(userInfo) : null
}

// 移除用户信息
export function removeUserInfo() {
  localStorage.removeItem('userInfo')
}

// 退出登录
export function logout() {
  removeToken()
  removeUserInfo()
} 


// WEBPACK FOOTER //
// ./src/utils/auth.js